// Format a calendar date (a day with no meaningful time-of-day) as M/D/YYYY.
//
// Service dates come from <input type="date"> as "YYYY-MM-DD" and are stored in
// Mongo as UTC-midnight timestamps ("YYYY-MM-DDT00:00:00.000Z"). Both parse to
// UTC midnight, so reading the UTC calendar fields yields the intended day in any
// runtime timezone. Using the local getters (or a bare toLocaleDateString) would
// shift the day backward in timezones west of UTC — the PPS-9 "reverts to today"
// bug. Do NOT use this for real timestamps like createdAt, which should display
// in local time.
export function formatCalendarDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()}/${d.getUTCFullYear()}`;
}
